import type { Ref } from "react";
import type { FocusGuideMethods } from "react-native";
import { View } from "react-native";

import type { TVFocusViewProps } from "./types";

const TVFocusGuideView = ({
  ref,
  destinations,
  ...restProps
}: TVFocusViewProps & { ref?: Ref<View & FocusGuideMethods> }) => (
  <View {...restProps} ref={ref} />
);

export default TVFocusGuideView;
